import keyEventMessageHandler from './key-event-message-handler';

export default {
  keyEventMessageHandler,
};
